<template>
    <div class="container">
        <div class="row">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">{{ quiz.name }}</h2>
                <p class="paragraph">Lorem ipsum dolor sit amet, consectetur. Cras id tempor tortor, vel vestibulum urna.</p>
            </div>
            <div class="col col-8">
                <div v-for="(question, qindex) in quiz.questions">
                    <h3>{{ question.id }}. {{ question.name }}</h3>
                    <div v-if="question.type == 'multiselect'">
                        <div class="form__input-container" v-for="(answer, aindex) in question.answers">
                            <input type="checkbox" name="showPrizes[]" :id="'showPrizes-' + answer.id" class="form__checkbox">
                            <label :for="'showPrizes-' + answer.id">
                                <span>{{ answer.name }}</span>
                            </label>                            
                        </div>
                    </div>
                    <div v-if="question.type == 'order'">
                        <draggable v-model="question.answers" :options="{group:'people'}" @start="drag=true" @end="drag=false">
                            <div v-for="element in question.answers" :key="element.id" style="cursor: move; border: 1px solid #000; margin-bottom: 5px;">{{element.name}}</div>
                        </draggable>
                    </div>
                </div>
                <button class="button button--small button--filled-blue prize__order-button" @click="send" :disabled="submitted">Wyślij &raquo;</button>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  name: 'QuizComponent',
  components: {
    draggable
  },
  data () {
    return {
        submitted: false,
        quiz: {
            id: 1,
            name: 'Pierwszy',
            created_at: '20.11.2018 10:40',
            questions: []
        }
    }
  },
  beforeRouteEnter(to, from, next) {      
    /**
     * Get current user object.
     */
    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/quizzes/' + to.params.id
      })
    ])
    .then(Vue.axios.spread((notificationsReponse) => {
        next(vm => {
            vm.questions = notificationsReponse.data.data.quiz[0].questions
        })
    }))
    .catch(error => next(false))
  },
  methods: {
    send: function() {
        var _this = this
        var prize_id = this.$route.params.id
        _this.submitted = true

        for( var item in this.modifiers ) {
            if( !this.modifiers[item] ) {
                _this.submitted = false
                return this.$toaster.error("Wybierz " + item + " nagrody")
            }
        }

        Vue.axios({
            method: 'post',
            url: '/prizes/order',
            data: {
                prizes: [
                    {
                        id: prize_id,
                        modifiers: this.modifiers
                    }
                ]
            }
        })
        .then(response => {
            this.$toaster.success(response.data.message)
            _this.submitted = false
        })
        .catch(error => {
            this.$toaster.error(error.response.data.message)
            _this.submitted = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/quizes/QuizSolveComponent.vue